// In different components where we show local maps and local lists,
// we may want to manage the filters as props or exposed in the URL.

// The `urlFilterKeys` specifies which props should be exposed in the URL:
// these are the filters users may want saved on the URL, e.g., to share with othersbundleRenderer.renderToStream
// The `propFilters` should be those that are controlled via props but not
// exposed in the URL. These are used when a component is automatically always
// applying a filter on a particular page, so that filter need not
// appear in the URL.
// For example, on the calendar hub, the calendar slug is a prop filter,
// but the searched location is a url filter key.
// Format: `urlFilterKeys` is a list of strings; `propFilters` is a list of objects
// with properties `type` and `value`.
export const filterManagerMixin = {
  props: {
    urlFilterKeys: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  computed: {
    propFiltersNotForUrl() {
      return this.propFilters.filter(f => !this.urlFilterKeys.includes(f.type))
    }
  }
}
